/* 全局消息事件(嵌套iframe消息事件)监听 */
import {
  registReturnGameFunction,
  registFunSuccessReportFunction,
  registRefreshFunction,
  registLoginVerifySuccessFunction,
  goToGameServerWithRoleId,
  createGameRoleWithRoleId,
  registLogoutFunction,
  updateLevelEventWithLevel,
  getDeviceMemoryInfo,
  handleNativeStorage,
  gameOpenDownloads,
  registerReportHandler
} from '@/bridge/AppJsBridge';
import moment from 'moment';
import { isPure, isAndroid } from '@/libs/utils';
import _ from 'lodash';
import { handleThirdLib } from '@/libs/business/account';
import { getStorage, customDialog } from '@/libs/utils';
import { globalErrReport } from '@/api/log';
import log from './log';


/* 
  action类型：
  getUser.游戏初始化调用
  setUser.游戏服务端二次验证成功后调用
  logout.登出
  showOrder.调起支付窗口
  cancelOrder.支付失败
  orderOk.支付成功
  shutDown.关闭登录窗口
  YWPlayerStatusCreate.创建角色
  YWPlayerStatusLevelUp.角色升级
  YWPlayerStatusEnterServer.进入服务器
  YwOpenOrder.打开了个新连接
  didReceiveMemoryWarning.ios获取内存信息
  */
const ACTION_LIST = [
  'getUser',
  'setUser',
  'logout',
  'showOrder',
  'cancelOrder',
  'orderOk',
  'shutDown',
  'YWPlayerStatusStartCreate',
  'YWPlayerStatusCreate',
  'YWPlayerStatusLevelUp',
  'YWPlayerStatusEnterServer',
  'YwOpenOrder',
  'getReceiveMemoryInfo',
  'setStorage',
  'getStorage',
  'gameOpenDownload',
  'getOrderState',
  'cxShowOrder'
];

export default {
  namespaced: true,
  state: {
    loginCallback: null,
    memoryCallback: null,
    notifyIdentifier: false,
    orderCallback: null
  },
  mutations: {
    CHANGE_STATE: (state, obj) => {
      state = Object.assign(state, obj);
    },
  },
  getters: {},
  actions: {
    monitorInit({ dispatch }) {
      window.addEventListener('message', function (e) {
        let obj = e.data;
        if (!obj || !obj.action || !obj.params) {
          // process.env.NODE_ENV != 'production' &&
          //   console.log('game msg params error:' + JSON.stringify(obj));
          return;
        }
        if (ACTION_LIST.includes(obj.action)) {
          dispatch(obj.action, obj);
        } else {
          console.warn(`unknown action ${obj.action}`);
        }
      });
    },
    logout() {
      // 清除微信登录凭证缓存，确保重新显示登录页面
      localStorage.removeItem('wechat_login_credential');
      localStorage.removeItem('wechatAccount');
      // 如果是h5，ios部分包未提供退出登录方法，需要刷新页面
      if (!isPure()) {
        location.reload();
      } else {
        registLogoutFunction(null);
      }
    },
    // 游戏初始化
    getUser({ state, rootState, commit }, obj) {
      const { callback } = obj.params;
      const { user } = rootState;
      if (user.h5Preload && !state.notifyIdentifier) {
        commit('CHANGE_STATE', { loginCallback: callback });
      } else {
        const params = {
          session_id: user.session_id,
          type: user.appkey,
          os: user.device_info.os,
          devicetype: user.device_info.devicetype,
          userId: user.user_id
        };
        window.frames['gameFrame'].postMessage({ action: callback, params }, '*');
      }
    },
    notifyLogin({ rootState, state, commit }) {
      const { loginCallback } = state;
      const { user } = rootState;
      const params = {
        session_id: user.session_id,
        type: user.appkey,
        os: user.device_info.os,
        devicetype: user.device_info.devicetype,
        userId: user.user_id
      };
      if (!loginCallback) {
        console.log('error: loginCallback undefined')
        commit('CHANGE_STATE', { notifyIdentifier: true })
        return;
      }
      window.frames['gameFrame'].postMessage({ action: loginCallback, params }, '*');
    },
    // 二次验证后
    async setUser({ rootState, commit, dispatch }, obj) {
      let userInfo = obj.params;
      const { user, global } = rootState;
      commit(
        'user/CHANGE_STATE',
        {
          user_id: userInfo.uid || user.user_id,
          username: userInfo.name || user.username,
          session_id: userInfo.session_id || user.session_id,
          thirdLoginVisible: false,
          loginVisible: false,
          cellLoginVisible: false,
          quickRegisterVisible: false,
          cellRegisterVisible: false,
          suspendVisible: true
        },
        { root: true }
      );
      const isSilentLogin = getStorage('isSilentLogin');
      if (isSilentLogin) {
        commit('user/CHANGE_STATE', { silentHintShow: true, suspendVisible: false }, { root: true });
        setTimeout(() => {
          commit('user/CHANGE_STATE', { silentHintShow: false }, { root: true });
        }, 2000)
      }
      commit('global/clearLoading', null, { root: true });

      const cacheList = ['user_id', 'username', 'session_id'];
      dispatch('user/cacheState', cacheList, { root: true });

      // 不显示悬浮窗的情况
      const forceNormalLogin = getStorage('force_normal_login')
      const ysdkStatus = isAndroid() && user.ysdk_status == 0 && !forceNormalLogin
      if (ysdkStatus || user.app_status == '1' || global.hidefloat) {
        commit('user/CHANGE_STATE', { suspendVisible: false }, { root: true });
      }

      dispatch('user/antiIndulged', null, { root: true });
      dispatch('user/blockDiagnose', null, { root: true });
      // dispatch('voucher/getShowList', null, { root: true });
      dispatch('suspend/getRemind', null, { root: true });
      // 通知APP登录成功
      registLoginVerifySuccessFunction({
        user_id: user.user_id,
        user_name: user.username,
        user_passwords: user.password,
        register_time: user.register_time,
        access_token: user.access_token
      });
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.registerReportHandler) {
          window.webkit.messageHandlers.registerReportHandler.postMessage({
            user_unique_id: user.user_id
          });
          // console.log('已触发iOS注册上报:', { user_unique_id: user.user_id });
      } else {
        console.warn('registerReportHandler not found');
      }
      setTimeout(() => {
        // // 显示强更礼包
        if (user.update_gift_status == 1) {
          commit('user/CHANGE_STATE', { updateGiftVisible: true }, { root: true });
        } else if (user.is_vip && user.vip_type == 2) {
          // 显示vip 两个弹框避开
          commit('user/CHANGE_STATE', { vipVisible: true }, { root: true });
        }
      }, 1000);

      // 逍遥合击查问题，临时增加日志上报
      const pid = getStorage('pid');
      if (pid == 102816) {
        globalErrReport({
          type: 'xyhj_h5_set_user',
          userId: userInfo.uid,
          appkey: user.appkey
        })
      }
    },
    async showOrder({ commit, rootState, dispatch }, obj) {

      let orderInfo = JSON.parse(obj.params);
      const { user } = rootState;

      if (user.appkey == '1') {

        let Obj = {
          title: "温馨提示",
          message: "支付维护，请前往小程序充值",
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }
        customDialog(Obj);
        commit('global/showCommonToast', '支付维护，请前往小程序充值', { root: true });
        commit('pay/CHANGE_STATE', { qrCodeVisible: false, qrCodeLink: '' }, { root: true });
      } else{
        // console.log('order info11', orderInfo);
        // orderInfo.appleProductId = 'miracles_id' + orderInfo.zfAmount/ 100;
        // console.log('order info22', orderInfo);
        // orderInfo.zfAmount = 1; // 测试金额1分
        // 获取内购商品ID列表
        try {
          const res = await dispatch('pay/fetchInnerProductIdList', null, { root: true });
          // console.log('内购接口响应:', res);
          
          // 检查内购是否开启（status === 1 表示开启）
          if (res && res.status === 1 && res.inner_product_id_list && Object.keys(res.inner_product_id_list).length > 0) {
            // console.log('内购已开启，商品ID列表:', res.inner_product_id_list);
            // console.log('商品ID列表详情:', JSON.stringify(res.inner_product_id_list, null, 2));
            
            // 判断当前金额是否有对应的内购ID
            const amount = String(orderInfo.zfAmount / 100);
            // console.log('当前充值金额:', amount, '元');
            
            // 根据金额找到对应的商品ID（key是商品ID，value是金额）
            const product_id = Object.keys(res.inner_product_id_list).find(key => res.inner_product_id_list[key] === amount);
            // const product_id = 'miracles_id6';
            // console.log('匹配到的商品ID:', product_id);
            
            if (product_id) {
              // console.log('找到内购商品ID:', product_id, '金额:', amount);
              
              // 先下单获取订单号
              const {
                global: { preventBrush },
                user: { extra_data, appkey, user_id, sdk_version, access_token, username }
              } = rootState;
              
              // 防止重复下单
              if (preventBrush) {
                console.log('防止重复下单，直接返回');
                return;
              }
              
              commit('global/CHANGE_STATE', { preventBrush: true }, { root: true });
              
              // 构建订单信息
              const order_Info = {
                cp_trade_no: orderInfo.orderId || orderInfo.cp_trade_no,
                notify_url: orderInfo.notifyUrl || orderInfo.notify_url,
                body: orderInfo.zfDesc || orderInfo.body,
                product_id: orderInfo.productId || orderInfo.product_id,
                product: orderInfo.productName || orderInfo.product,
                exchange_rate: orderInfo.rate || orderInfo.exchange_rate,
                app_role_id: orderInfo.roleId || orderInfo.app_role_id,
                app_role_name: orderInfo.roleName || orderInfo.app_role_name,
                server_id: orderInfo.serverId || orderInfo.server_id,
                total_fee: orderInfo.zfAmount || orderInfo.total_fee
              };

              
              
              try {
                // 调用内购下单接口
                const result = await dispatch('pay/placeInnerOrder', order_Info, { root: true });
                // console.log('内购下单结果:', result);
                
                if (result.success && result.data) {
                  const { order_sn } = result.data;
            
                  // 如果下单成功，获取到订单号
                  if (order_sn) {
                    // console.log('下单成功，订单号:', order_sn);
                    // 触发 iOS 内购
                    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.miraclesHandler) {
                      window.webkit.messageHandlers.miraclesHandler.postMessage({
                        order: order_sn, // 订单号
                        pid: product_id // 内购ID
                      });
                      // console.log('已触发iOS内购:', { order_sn: order_sn, pid: product_id });
                      
                      // 重置防重复点击状态
                      commit('global/CHANGE_STATE', { preventBrush: false }, { root: true });
                      return; // 直接返回，不再走原有支付流程
                    } else {
                      console.warn('miraclesHandler not found');
                    }
                  } else {
                    console.error('下单失败，没有获取到订单号');
                  }
                } else {
                  console.error('下单失败:', result.error);
                }
              } catch (error) {
                console.error('下单失败:', error);
              }
              
              // 重置防重复点击状态
              commit('global/CHANGE_STATE', { preventBrush: false }, { root: true });
            } else {
              console.log('未找到对应的内购商品ID，金额:', amount);
            }
          } else {
            console.log('内购未开启或商品列表为空，status:', res?.status);
          }
        } catch (error) {
          console.error('获取内购商品ID列表失败:', error);
        }
        
        // 非内购或内购失败，走原有支付逻辑
        dispatch('pay/getPayTypeList', orderInfo, { root: true });
        commit('pay/CHANGE_STATE', { order_info: orderInfo, qrCodeVisible: false, qrCodeLink: '' }, { root: true });
      }
      // 重置支付窗口状态和防重复点击状态
      commit('global/CHANGE_STATE', { preventBrush: false }, { root: true });
    },
    cxShowOrder({ commit, rootState, dispatch }, obj) {
      //console.log('order info', JSON.parse(obj.params))
      const { callback, param } = obj.params;
      console.log(callback);
      let orderInfo = JSON.parse(param);
      if (callback) {
        commit('CHANGE_STATE', { orderCallback: callback });
      }
      dispatch('pay/getPayTypeList', orderInfo, { root: true });
      commit('pay/CHANGE_STATE', { order_info: orderInfo, qrCodeVisible: false, qrCodeLink: '' }, { root: true });
      // 重置支付窗口状态和防重复点击状态
      commit('global/CHANGE_STATE', { preventBrush: false }, { root: true });
    },

    cancelOrder({ commit, dispatch }) {
      dispatch('pay/queryOrderResult', { root: true });
      // console.log('支付失败');
      // commit('global/showCommonToast', '支付失败，支付结果请以实际游戏币为准', { root: true });
      // commit('user/CHANGE_STATE', { chargeVisible: false }, { root: true })
      // commit('pay/CHANGE_STATE', { orderShow: false, orderIframeLink: '' }, { root: true })
    },
    // 支付成功
    orderOk({ commit, rootState, dispatch }) {
      // console.log('支付成功');
      dispatch('pay/queryOrderResult', { root: true });
      // commit('global/showCommonToast', '支付成功，支付结果请以实际游戏币为准', { root: true });
      // commit('user/CHANGE_STATE', { chargeVisible: false }, { root: true });
      // const {
      //   pay: { order_info, thirdLibs, img_class_name, pay_type, order_sn },
      //   user: { user_id }
      // } = rootState;
      // let orderInfo = _.cloneDeep(order_info);
      // if (isAndroid()) {
      //   orderInfo.zfAmount =
      //     handleThirdLib(orderInfo.zfAmount / 100, thirdLibs) || orderInfo.zfAmount / 100;
      // } else {
      //   orderInfo.zfAmount =
      //     handleThirdLib(orderInfo.zfAmount, thirdLibs) || orderInfo.zfAmount;
      // }
      // orderInfo.type = img_class_name
      // orderInfo.pay_type = pay_type;
      // orderInfo.uid = user_id;
      // orderInfo.yw_order_sn = order_sn;
      // registFunSuccessReportFunction(orderInfo);
      // commit('pay/CHANGE_STATE', {
      //   orderShow: false,
      //   orderIframeLink: '',
      //   order_sn: ''
      // }, { root: true });
      // setTimeout(function() {
      //   registReturnGameFunction(null);
      // }, 2000);
    },
    // 关闭登录框（跳过二次验证赋值）
    shutDown({ dispatch }) {
      dispatch('setUser', { params: {} });
    },
    // 进入创角界面
    YWPlayerStatusStartCreate({ dispatch }, obj) {
      dispatch('log/roleCreateReport', obj.params, { root: true });
    },
    // 角色创建
    YWPlayerStatusCreate({ dispatch }, obj) {
      dispatch('log/roleUpdateReport', obj.params, { root: true });
      dispatch('log/roleCreateSuccessReport', obj.params, { root: true });
      createGameRoleWithRoleId(obj.params);
    },
    // 角色升级
    YWPlayerStatusLevelUp({ dispatch }, obj) {
      dispatch('log/roleUpdateReport', obj.params, { root: true });
      updateLevelEventWithLevel(obj.params);
    },
    // 进入服务器
    YWPlayerStatusEnterServer({ dispatch, commit }, obj) {
      const { roleId, roleLevel, roleName, serverName, serverId, serverCreatedAt } = obj.params
      // 进入服务器日志上报
      dispatch('log/enterServerReport', obj.params, { root: true });
      dispatch('log/enterServerGSReport', obj.params, { root: true });
      dispatch('activity/handleActivityShow', obj.params, { root: true });
      commit('suspend/CHANGE_STATE', {
        role: {
          role_id: roleId,
          level: roleLevel,
          role_name: roleName,
          server_name: serverName,
          server_id: serverId,
          server_created_at: serverCreatedAt
        }
      }, { root: true })
      commit('redEnvelope/CHANGE_STATE', {
        role: {
          role_id: roleId,
          level: roleLevel,
          role_name: roleName,
          server_name: serverName,
          server_num: serverId,
          server_created_at: serverCreatedAt
        }
      }, { root: true })
      if (obj.params) {
        commit('user/CHANGE_STATE', {
          server: obj.params.serverName,
          role_name: obj.params.roleName
        }, { root: true })
        dispatch('user/cacheState', ['server', 'role_name'], { root: true })
      }
      goToGameServerWithRoleId(obj.params);
    },
    YwOpenOrder({ }, obj) {
      location.href = obj.params;
    },
    // ios获取内存信息
    getReceiveMemoryInfo({ commit }, obj) {
      const { callback } = obj.params;
      commit('CHANGE_STATE', { memoryCallback: callback })
      getDeviceMemoryInfo((params) => {
        window.frames['gameFrame'].postMessage({ action: callback, params }, '*');
      })
    },
    setStorage({ commit }, obj) {
      console.log(281, obj)
      handleNativeStorage({
        gs: 0,
        key: obj.params.key,
        value: obj.params.value,
      }, function (data) {
      })
    },
    getStorage({ commit }, obj) {
      handleNativeStorage({
        gs: 1,
        key: obj.params.key,
        value: "",
      }, function (data) {
        window.frames['gameFrame'].postMessage({ action: 'getStorageCallback', params: data }, '*');
      })
    },
    gameOpenDownload({ commit }, obj) {
      gameOpenDownloads({
        gameUrl: obj.params
      })
    },
  }
};
